import React from 'react';
import { List, Flex } from 'antd-mobile';
import { Icon } from 'react-onsenui';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { v4 as uuid4 } from 'uuid';
class FreeKickTeamChoice extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            seanceHome: [],
            seanceAway: [],
            startIndexHome: 0,
            startIndexAway: 0
        }
        this.initCircles = this.initCircles.bind(this)
    }

    componentDidMount() {
        const circlesHome = this.initCircles();
        const circlesAway = this.initCircles();
        const {seq} = this.props;
        const takeSeanceHome = _.takeRight(_.orderBy(_.filter(seq, s => s.eq === 'home'), 'id', 'asc'),5);
        const takeSeanceAway = _.takeRight(_.orderBy(_.filter(seq, s => s.eq === 'away'), 'id', 'asc'),5);

        _.forEach(takeSeanceHome, (v,i) => {
            circlesHome[i] = v.result === 'marque' ? {icon: 'md-check-circle', color: 'green'} : {icon: 'md-close-circle', color: 'red'};
        })

        _.forEach(takeSeanceAway, (v,i) => {
            circlesAway[i] = v.result === 'marque' ? {icon: 'md-check-circle', color: 'green'} : {icon: 'md-close-circle', color: 'red'};
        })

        this.setState({seanceHome: circlesHome, seanceAway: circlesAway});
    }

    initCircles() {
        const circles = []
        for(let i=0; i < 5; i++) {
            circles.push({icon: 'md-circle-o', color: 'black'})
        }
        
        return circles;
    }

    componentDidUpdate(prevProps) {
        const {seq} = this.props;
        const {startIndexAway, startIndexHome} = this.state;
        
        if(!_.isEqual(prevProps.seq, seq) && !_.isEmpty(seq)) {

            const promiseHome = new Promise((resolve, reject) => {
                const sHomePrev = _.filter(prevProps.seq, s => s.eq === 'home');
                if(startIndexHome !== sHomePrev.length && sHomePrev.length !== 0 && sHomePrev.length % 5 === 0) {
                    this.setState(prevState => {
                        return {
                            startIndexHome: prevState.startIndexHome + 5
                        }
                    }, () => resolve());
                }
                else {
                    resolve();
                }
            });

            const promiseAway = new Promise((resolve, reject) => {
                const sAway = _.filter(prevProps.seq, s => s.eq === 'away');
                if(startIndexAway !== sAway.length && sAway.length !== 0 && sAway.length % 5 === 0) {
                    this.setState(prevState => {
                        return {
                            startIndexAway: prevState.startIndexAway + 5
                        }
                    }, () => resolve());
                }
                else {
                    resolve();
                }
            });

            Promise.all([promiseHome, promiseAway]).then(() => {
                const takeSeanceHome = _.take(_.slice(_.filter(seq, s => s.eq === 'home'),startIndexHome) ,5);
                const takeSeanceAway = _.take(_.slice(_.filter(seq, s => s.eq === 'away'),startIndexAway), 5);
                const circlesHome = this.initCircles();
                const circlesAway = this.initCircles();

                _.forEach(takeSeanceHome, (v,i) => {
                    circlesHome[i] = v.result === 'marque' ? {icon: 'md-check-circle', color: 'green'} : {icon: 'md-close-circle', color: 'red'};
                })

                _.forEach(takeSeanceAway, (v,i) => {
                    circlesAway[i] = v.result === 'marque' ? {icon: 'md-check-circle', color: 'green'} : {icon: 'md-close-circle', color: 'red'};
                })

                this.setState({seanceHome: circlesHome, seanceAway: circlesAway});
            });
        }
        else if(!_.isEqual(prevProps.seq, seq) && _.isEmpty(seq)) {
            this.setState({seanceHome: this.initCircles(), seanceAway: this.initCircles()});
        }
    }
    
    render() {
        const {homeTeamLogo, homeTeamName, awayTeamLogo, awayTeamName, score} = this.props;
        const { seanceHome, seanceAway } = this.state;

        return (
            <List>
                <List.Item multipleLine wrap>
                    <Flex justify='center'>
                        <div className='center-align'>
                            <Flex>
                                <div style={styles.container_team}><img style={styles.logo_team} src={homeTeamLogo} alt={homeTeamName} /></div>
                                <div>
                                    {seanceHome.map(element => <Icon key={uuid4()} size={20} icon={element.icon} style={{...styles.circle, color: element.color}} />)}
                                </div>
                            </Flex>
                        </div>
                        <div className='box-score center-align' style={styles.container_box_score}>
                            <div className="score" style={styles.box_score}>{score.home}:{score.away}</div>
                        </div>
                        <div className='center-align'>
                            <Flex>
                                <div>
                                    {seanceAway.map(element => <Icon key={uuid4()} size={20} icon={element.icon} style={{...styles.circle, color: element.color}} />)}
                                </div>
                                <div style={styles.container_team}><img style={styles.logo_team} src={awayTeamLogo} alt={awayTeamName} /></div>
                            </Flex>
                        </div>
                    </Flex>
                </List.Item>
            </List>
        )
    }
}

const styles = {
    container_box_score: {
        minWidth: '33px', 
        marginLeft: 5, 
        marginRight: 5
    },
    box_score: {
        backgroundColor: '#004586',
        color: '#fff',
        padding: 5,
        borderRadius: 7,
        fontSize: 16,
        fontWeight: 700
    },
    logo_team: {
        width: 25,
        height: 25
    },
    circle: {
        paddingLeft: 3,
        paddingRight: 3
    },
    container_team: {
        marginRight: 3
    }
}

FreeKickTeamChoice.propTypes = {
    homeTeamLogo: PropTypes.string,
    awayTeamLogo: PropTypes.string,
    homeTeamName: PropTypes.string,
    awayTeamName: PropTypes.string,
    score: PropTypes.shape({
        home: PropTypes.number,
        away: PropTypes.number
    }),
    seq: PropTypes.array
}

export default FreeKickTeamChoice;